/* eslint-disable no-redeclare */
export const LocaleCode = {
    DE_CH: 'de-CH',
    FR_CH: 'fr-CH',
} as const;
export type LocaleCode = (typeof LocaleCode)[keyof typeof LocaleCode];
